import {
  FETCH_MOST_TUTORIALS,
  FETCH_TUTORIAL_LIST,
  FETCH_TUTORIAL_STEPS,
  UPDATE_STEP,
  UPDATE_STEP_NB,
  UPDATE_FRAME,
  ANIMATE_STEP,
  ANIMATE_ALL,
  ANIMATE_ALL_TERM
} from './constants'

const initialState = {
  isFetching: false,
  mostSeenTutorials: [],
  tutorials: [],
  currentTutorial: [],
  currentPhoneId: null,
  currentTutorialId: null,
  currentStep: 0,
  currentFrame: -1,
  isPlayingStep: false,
  isPlayingAll: false
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_MOST_TUTORIALS.REQUEST: {
      return {
        ...state,
        isFetching: true,
        mostSeenTutorials: []
      }
    }
    case FETCH_MOST_TUTORIALS.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        mostSeenTutorials: action.tutorials,
        currentPhoneId: action.currentPhoneId
      }
    }
    case FETCH_TUTORIAL_LIST.REQUEST: {
      return {
        ...state,
        isFetching: true,
        tutorials: []
      }
    }
    case FETCH_TUTORIAL_LIST.SUCCESS: {
      return {
        ...state,
        currentPhoneId: action.currentPhoneId,
        tutorials: action.tutorials,
        isFetching: false
      }
    }
    case FETCH_TUTORIAL_STEPS.REQUEST: {
      return {
        ...state,
        isFetching: true,
        currentTutorial: []
        // currentTutorialId: null
      }
    }
    case FETCH_TUTORIAL_STEPS.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        currentTutorial: action.tutorial,
        currentTutorialId: action.tutorialId,
        currentStep: 0,
        currentFrame: -1,
        isPlayingStep: false,
        isPlayingAll: false
      }
    }
    case UPDATE_STEP: {
      return {
        ...state,
        currentFrame: -1,
        currentStep: action.step,
        isPlayingStep: false,
        isPlayingAll: false
      }
    }
    case UPDATE_STEP_NB: {
      return {
        ...state,
        currentFrame: -1,
        currentStep: action.step,
        isPlayingStep: false
      }
    }
    case UPDATE_FRAME: {
      return {
        ...state,
        currentFrame: action.index
      }
    }
    case ANIMATE_STEP: {
      return {
        ...state,
        isPlayingStep: true
      }
    }
    case ANIMATE_ALL: {
      return {
        ...state,
        isPlayingAll: true
      }
    }
    case ANIMATE_ALL_TERM: {
      return {
        ...state,
        isPlayingAll: false
      }
    }
    default: {
      return state
    }
  }
}
